import React, {useState, useEffect} from 'react';
import Checkbox from '@mui/material/Checkbox';
import {TipoServiciosEmpresaMiEmpresa} from '../CategoriasEmpresa/TipoServiciosEmpresaMiEmpresa';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {eliminarEspaciosYCamelizar} from '../../fuctions/eliminarEspaciosYCamelizar';
import axios from 'axios';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {useNavigate} from 'react-router-dom';
import {animateScroll as scroll} from 'react-scroll';
import {InputsFormularioMiEmpresa} from './InputsFormularioMiEmpresa';

export const FormularioEmpresaMiEmpresa = (props) => {
	/* Destructuring the props object. */
	const {
		guardarCambios,
		borrarCuenta,
		setPantallaPerfil,
		idEmpresa,
		atras,
		registroEmpresa,
		empresa,
		setEmpresa,
	} = props;

	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	const [FotoPerfilCambiar, setFotoPerfilCambiar] = useState();

	const [ModalActulizacionOk, setModalActulizacionOk] = useState(false);
	const [ModalBorrarCuenta, setModalBorrarCuenta] = useState(false);
	const [ModalCambiarFotoPerfil, setModalCambiarFotoPerfil] = useState(false);
	const [ModalFotoCambiadaOK, setModalFotoCambiadaOK] = useState(false);
	const [ModalFotoCambiadaNoOK, setModalFotoCambiadaNoOK] = useState(false);
	/* Creating a state variable called ErroresFormulario and a function to update it called
    setErroresFormulario. */
	const [ErroresFormulario, setErroresFormulario] = useState([]);

	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	/* Declaring a variable called IsDisabled and setting it to false. */
	const [IsDisabled, setIsDisabled] = useState(false);

	const navigate = useNavigate();

	/**
	 * It gets the image from the server and sets the state of the component with the image
	 * @param {Object} usuario - The user object containing the access token and user data.
	 * @param {Object} foto- The prhoto user.
	 */
	const colocarFoto = (usuario, foto) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilEmpresa/' + foto.id.toString() + '/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			responseType: 'blob',
		})
			.then((response) => {
				setUsuario({
					...usuario,
					fotoPerfil: URL.createObjectURL(response.data),
				});
				//navigate("/miEmpresa");
			})
			.catch((error) => {
				setUsuario({
					...usuario,
					fotoPerfil:
						'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
				});
				setErroresFormulario(['Error al cargar la foto de perfil #345']);
				setModalErrores(true);
			});
	};

	/**
	 * It gets the image of the user from the database and then calls the function colocarFoto()
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const selectFotoPerfil = (usuario, funtion) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilEmpresa/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				if (response.data && response.data.length > 0) {
					if (funtion === 0) {
						return colocarFoto(usuario, response.data[0]);
					} else {
						return borrarFotoAntigua(response.data[0]);
					}
				} else {
					if(funtion === 1) {
						cambiarFotoPerfil();
					};
				}
			})
			.catch((error) => {
				setUsuario({
					...usuario,
					fotoPerfil:
						'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
				});
				setErroresFormulario(['Error al cargar la foto de perfil #344']);
				setModalErrores(true);
			});
	};
	/* Calling the functions definirServicios() and definirCategorias() when the component is mounted. */
	useEffect(() => {
		/* Calling the scrollToTop() method on the scroll object. */
		selectFotoPerfil(Usuario, 0);
		scroll.scrollToTop();
		/* Defining the services and categories. */
	}, []);

	/**
	 * If the email address is not in the form of a string, return false. If the email address is in
	 * the form of a string, return true.
	 * @returns A boolean value.
	 */
	const emailErroneo = (email) => {
		var validator = require('email-validator');
		return validator.validate(email);
	};

	/**
	 * If the postal code is not 5 digits, then return false.
	 * @returns The function codigoPostalErroneo is being returned.
	 */
	const codigoPostalErroneo = (postalCode) => {
		/* The above code is a regular expression that checks if a string is 5 digits long. */
		var pattern = /^\d{5}$/;
		/* The above code is checking if the postal code is in the correct format. */
		return pattern.test(postalCode);
	};

	/**
	 * It returns true if the string is a valid Spanish phone number, and false otherwise.
	 * @returns A boolean value.
	 */
	const telefonoErroneo = (telefono) => {
		/* A regular expression that checks if a phone number is valid. */
		var pattern = /^(\+34|0034|34)?[6789]\d{8}$/;
		/* Checking if the phone number is valid. */
		return pattern.test(telefono);
	};

	/**
	 * If the length of the string is greater than 4, return true, otherwise return false.
	 * @returns const datosVacio = (dato) => {
	 *         return dato.length > 4
	 *     }
	 */
	const datosVacio = (dato) => {
		return dato.length >= 4;
	};

	/**
	 * "If the password and the repeated password are not the same, push the error message to the list
	 * of errors, if the password is less than 10 characters or the password is wrong, push the error
	 * message to the list of errors, if the email is wrong, push the error message to the list of
	 * errors, if the postal code is wrong, push the error message to the list of errors, if the phone
	 * number is wrong, push the error message to the list of errors, if the name of the company is
	 * empty, push the error message to the list of errors, if the name of the contact is empty, push
	 * the error message to the list of errors, if the last name of the contact is empty, push the
	 * error message to the list of errors, if the address is empty, push the error message to the list
	 * of errors, if the company's website is empty, push the error message to the list of errors, if
	 * the list of errors is and if it list of error don`t have errors, create user else (Salta modal de errores)
	 */
	const comprobarDatos = () => {
		let listaErrores = [];
		/*
       /* *|MARKER_CURSOR|* */

		/* Checking if the email is valid. */
		if (!emailErroneo(empresa.emailEmpresa)) {
			listaErrores.push('El email introducido es erróneo');
		}

		/* Checking if the postal code is correct. */
		if (!codigoPostalErroneo(empresa.codigoPostal)) {
			listaErrores.push('El código postal introducido es erróneo');
		}

		/* Checking if the phone number is valid. */
		if (!telefonoErroneo(empresa.telefono)) {
			listaErrores.push('El teléfono introducido es erróneo');
		}

		/* Checking if the value of the field is empty. */
		if (!datosVacio(empresa.nombreEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo prestador de servicios');
		}

		/* Checking if the value of the variable empresa.nombreContactoEmpresa is empty. */
		if (!datosVacio(empresa.nombreContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo nombre contacto');
		}

		/* Checking if the value of the input field is empty. */
		if (!datosVacio(empresa.apellidosContactoEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo apellidos');
		}

		/* Checking if the value of the variable empresa.direccion is empty. */
		if (!datosVacio(empresa.direccion)) {
			listaErrores.push('Debe introducir un valor válido en el campo dirección');
		}

		/* Checking if the value of the webEmpresa is empty. */
		if (!datosVacio(empresa.webEmpresa)) {
			listaErrores.push('Debe introducir un valor válido en el campo web Empresa');
		}
		/* Checking if the list of errors is empty. If it is empty, it will create a user. If it is not
        empty, it will set the errors in the form and set the modal errors to true. */
		if (listaErrores.length === 0) {
			crearUsuario();
			/* Creating a new user. */
		} else {
			/* Setting the error message error form to be displayed in the modal. */
			setErroresFormulario(listaErrores);
			setModalErrores(true);
		}
	};

	/**
	 * It takes the data from the form and sends it to the backend to update the user.
	 */
	const updateUser = () => {
		let data = {
			username: eliminarEspaciosYCamelizar(empresa.nombreEmpresa),
			email: empresa.emailEmpresa,
		};
		axios({
			method: 'patch',
			url: window.ipdirection + 'usuarioByUsuario/' + empresa.usuario.id + '/',
			data: {
				...data,
			},
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				// Definir categorias
				//modificarCategorias();
				setModalActulizacionOk(true);
			})
			.catch((error) => {
				setErroresFormulario([
					'No se pudo actualizar la informaición realacionada con la inofrmación básica de la empresa',
				]);
				setModalErrores(true);
			});
	};

  const crearUsuario = () => {
    let data = {
      nombreEmpresa: empresa.nombreEmpresa,
      nombreContactoEmpresa: empresa.nombreContactoEmpresa,
      apellidosContactoEmpresa: empresa.apellidosContactoEmpresa,
      telefono: empresa.telefono,
      direccion: empresa.direccion,
      codigoPostal: empresa.codigoPostal,
      webEmpresa: empresa.webEmpresa,
      emailEmpresa: empresa.emailEmpresa,
      tamañoEmpresa: empresa.tamañoEmpresa,
      shareCare: empresa.shareCare,
      descripcionEmpresa: empresa.descripcionEmpresa,
      notasEmpresa: empresa.notasEmpresa,
      estado: "activo",
    };
    axios({
      method: "patch",
      url: window.ipdirection + "prestadorServicios/" + empresa.id + "/",
      data: {
        ...data,
      },
      headers: {
        Authorization: "Bearer " + Usuario.access,
      },
    })
      .then((response) => {
        // Nos logeamos como empresa
        // para meter en el usuario los datos de la empresa
        updateUser();
        // HACER SUBCONSULTA PARA EL USUARIO
        // añadimos y enviamos las categorias que se ha selecionado
      })
      .catch((error) => {
        /* A catch block that is catching an error. */
        // Añadimos los errores al modal
        let listaErrores = [];
        setErroresFormulario([
          "No se pudo actulizar la informaición realacionada con la empresa",
        ]);
        setModalErrores(true);
      });
  };

	/**
	 * A function that handles the change of the input.
	 */
	const handleInpuntChange = (e) => {
		const {name, value} = e.target;
		setEmpresa({
			...empresa,
			[name]: value,
		});
	};
	/**
	 * The function takes an event as an argument, and then sets the state of the component to the
	 * value of the event
	 */
	const handleChangeTamañoEmpresa = (event) => {
		const min = 1;
		const max = 1000000;
		/* Setting the value of the input field to the value of the state. */
		const value = Math.max(min, Math.min(max, Number(event.target.value)));
		setEmpresa({
			...empresa,
			tamañoEmpresa: value,
		});
	};

	/**
	 * A function that changes the state of the variable "shareCare" to the opposite of what it was.
	 */
	const filtroShareCare = () => {
		/* Setting the state of the empresa object. */
		setEmpresa({
			...empresa,
			shareCare: !empresa.shareCare,
		});
	};

  const borrarFotoAntigua = (foto) => {
    axios({
      url:
        window.ipdirection + "imagenPerfilEmpresa/" + foto.id.toString() + "/",
      method: "delete",
      headers: {
        Authorization: "Bearer " + Usuario.access,
      },
    })
      .then((response) => {
        cambiarFotoPerfil();
      })
      .catch((error) => {
        setErroresFormulario(["Fallo al actulizar su foto de perfil"]);
        setModalErrores(true);
      });
  };

	const actualizarFoto = () => {
		let correct = false;
		if (FotoPerfilCambiar !== null) {
			if (FotoPerfilCambiar !== undefined) {
				if (FotoPerfilCambiar.fotoPerfil !== null) {
					if (FotoPerfilCambiar.fotoPerfil !== undefined) {
						if (
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpg' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/png' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpeg'
						) {
							selectFotoPerfil(Usuario, 1);
							correct = true;
						}
					}
				}
			}
		}
		if (!correct) {
			setModalFotoCambiadaNoOK(true);
		}
	};

	const cambiarFotoPerfil = () => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoPerfilCambiar.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, Usuario.prestadorServicios.nombreEmpresa + '.png');
				formData.append('nombre', 'FotoPerfil-' + Usuario.prestadorServicios.nombreEmpresa);
				//formData.append("nombre", "Prueba");
				formData.append('usuario_id', Usuario.prestadorServicios.usuario.id);

				axios
					.post(window.ipdirection + 'imagenPerfilEmpresa/', formData, {
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
					})
					.then((response) => {
						selectFotoPerfil(Usuario, 0);
						setModalCambiarFotoPerfil(false);
						setModalFotoCambiadaOK(true);
					})
					.catch((error) => {
						setErroresFormulario(['Error al enviar la foto de perfil']);
						setModalErrores(true);
					});
			});
		};
	};

	const eliminarCuenta = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'prestadorServicios/' + empresa.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setModalBorrarCuenta(false);
				navigate('/');
				setUsuario({
					tipo: 'noRegistrado',
					userName: '',
					email: '',
					imagen: '',
				});
			})
			.catch((error) => {
				setErroresFormulario([error]);
				setModalErrores(true);
			});
	};

	return (
		<>
			<div className='formulario-mi-empresa'>
				<div className='centradorRight'>
					<div
						className='button'
						onClick={() => setIsDisabled(!IsDisabled)}
					>
						<b>Modificar</b>
					</div>
				</div>
				<div className='content-formulario-mi-empresa'>
					<div className='superior-formulari-miempresa'>
						<div className='centrador divImagenPerfilFondo'>
							<img
								src={Usuario.fotoPerfil}
								className='imagenPerfilMiPerfil '
							/>
							<div className='iconoCambioFotoPerfil centrador'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									fill='currentColor'
									className='bi bi-plus-circle-fill'
									viewBox='0 0 16 16'
									onClick={() => setModalCambiarFotoPerfil(true)}
								>
									<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
								</svg>
							</div>
						</div>
						<div className='centrador nombreID'>
							<div>
								<div className='centrador nombreUsuarioForm'>
									{empresa.nombreEmpresa}
								</div>
								{/*<div className='IDUsuario'><b>ID : </b>
                                {
                                    (registroEmpresa)
                                        ? <p>-------</p>
                                        : idEmpresa
                                }
                            </div>*/}
							</div>
						</div>
					</div>
					<div className='inputs-formulaio-miEmpresa'>
						<InputsFormularioMiEmpresa
							empresa={empresa}
							handleInpuntChange={handleInpuntChange}
							handleChangeTamañoEmpresa={handleChangeTamañoEmpresa}
							filtroShareCare={filtroShareCare}
							isDisabled={!IsDisabled}
						/>
					</div>
				</div>
				<div className='buttonGuardar'>
					<div
						className='button borrarCuenta'
						onClick={() => setModalBorrarCuenta(true)}
					>
						<b>Borrar cuenta</b>
					</div>
					<div
						className='button'
						Id='buttonGuardarFormUsu'
						onClick={comprobarDatos}
					>
						<b>Guardar</b>
					</div>
					{/* 
          <div
            className="button borrarCuenta"
            Id="button buttonBorrarFormUsu"
            onClick={borrarCuenta}
          >
            <b>Borrar Usuario</b>
          </div>
          */}
				</div>
			</div>

			<Modal
				centered={true}
				isOpen={ModalBorrarCuenta}
			>
				<ModalHeader>
					<div className='titulo-modal'>Borrar Cuenta</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						¿Está seguro de que desea eliminar esta cuenta?
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => eliminarCuenta()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaNoOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Ups... Parece que no se puede subir la foto
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaNoOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalCambiarFotoPerfil}
			>
				<ModalHeader>
					<div className='titulo-modal'>Actualiza la imagen de tu perfil empresarial</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						<p>
							Selecciona la foto de perfil para tu empresa. Para una correcta
							visualización, se recomienda que la imagen tenga unas proporciones
							cuadradas: 300x300, 500x500, etc...
						</p>
						<input
							type='file'
							className='inputTextUsuario inputFile'
							accept='image/*'
							onChange={(e) =>
								setFotoPerfilCambiar({
									...setFotoPerfilCambiar,
									fotoPerfil: e.target.files[0],
								})
							}
						/>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => setModalCambiarFotoPerfil(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => actualizarFoto()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Tu foto de perfil empresarial ha sido actualizada correctamente
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalActulizacionOk}
			>
				<ModalHeader>
					<div className='titulo-modal'>¡Listo para brillar!</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Felicidades, ¡tu perfil empresarial ha sido actualizado con éxito! Ahora
						puedes destacar con una imagen más fresca y una información actualizada.
						Gracias por mantener tu perfil actualizado y ayudarnos a brindar la mejor
						experiencia posible a nuestros usuarios. ¡Sigue adelante y haz que tu
						empresa brille en nuestra plataforma!
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalActulizacionOk(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalErrores}
			>
				<ModalHeader>
					<div className='titulo-modal'>
						Uno o varios datos del formulario de registro no son validos
					</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{ErroresFormulario.map((error) => (
							<div> - {error} </div>
						))}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='button-modal-registroEmpresa centrador'>
						<div
							className='button'
							onClick={() => {
								setModalErrores(false);
								setErroresFormulario([]);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
